/*
  CART EXTRAS — Club Partner
  ---------------------------------------------------------------------------
  Adds a free-shipping progress bar to the "added to cart" popup and to the
  cart page, plus a small trust line under the cart's checkout button.

  The free-shipping amount comes from the script tag (data-free-cents, set in
  snippets/cp-cart-extras.liquid). It matches Shopify's shipping settings:
  Domestic "Free Shipping" on orders of $40.00 or more.

  Dawn redraws parts of the cart whenever something changes, which would wipe
  anything added inside them. So after every change (Dawn's own "cart-update"
  message, plus a watcher for anything else) the bar is checked and put back.
*/
(function () {
  'use strict';

  var ME = document.currentScript;
  var FREE = parseInt(ME && ME.getAttribute('data-free-cents'), 10) || 4000;
  var cart = null, busy = false;

  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
  var TRUCK = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v10H3z"/><path d="M14 9h4l3 3.5V16h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function barHTML(total) {
    var done = total >= FREE, pct = Math.max(4, Math.min(100, Math.round(total / FREE * 100)));
    var text = done
      ? 'Your order ships <b>free</b>.'
      : 'You’re <b>' + money(FREE - total) + '</b> away from <b>free shipping</b>.';
    return '<div class="cpc-bar-top">' + (done ? CHECK : TRUCK) + '<span>' + text + '</span></div>'
      + '<div class="cpc-track" aria-hidden="true"><span style="width:' + (done ? 100 : pct) + '%"></span></div>';
  }

  function ensure(where, before, cls) {
    if (!where) return null;
    var el = where.querySelector(':scope > .' + cls);
    if (!el) {
      el = document.createElement('div');
      el.className = 'cpc-bar ' + cls;
      el.setAttribute('role', 'status');
      where.insertBefore(el, before && before.parentNode === where ? before : where.firstChild);
    }
    return el;
  }

  function paint() {
    if (!cart) return;
    var total = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    var empty = !cart.item_count;

    // 1. The "added to cart" popup: above its buttons.
    var pop = document.getElementById('cart-notification');
    if (pop) {
      var links = pop.querySelector('.cart-notification__links');
      var bar = links && ensure(links.parentNode, links, 'cpc-bar--pop');
      if (bar) { bar.hidden = empty; bar.classList.toggle('is-free', total >= FREE); bar.innerHTML = barHTML(total); }
    }

    // 2. The cart page: above the total, plus a trust line under the checkout buttons.
    var blocks = document.querySelector('.cart__footer .cart__blocks');
    if (blocks) {
      var pb = ensure(blocks, blocks.firstChild, 'cpc-bar--page');
      pb.hidden = empty; pb.classList.toggle('is-free', total >= FREE); pb.innerHTML = barHTML(total);
      if (!blocks.querySelector(':scope > .cpc-trust')) {
        var t = document.createElement('ul');
        t.className = 'cpc-trust';
        t.innerHTML = '<li>Ships in 1 business day</li><li><a href="/policies/refund-policy">14-day returns</a></li><li>Secure checkout</li>';
        blocks.appendChild(t);
      }
    }
  }

  function refresh() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; paint(); })
      .catch(function () { /* leave it */ })
      .then(function () { busy = false; });
  }

  function start() {
    refresh();
    // Dawn announces every cart change on its own message board.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 60); });
    }
    // Belt and braces: if Dawn redraws the cart footer or popup, put the bar back.
    var mo = new MutationObserver(function () {
      if (!cart) return;
      var needPop = document.querySelector('.cart-notification__links') && !document.querySelector('.cpc-bar--pop');
      var needPage = document.querySelector('.cart__footer .cart__blocks') && !document.querySelector('.cpc-bar--page');
      if (needPop || needPage) paint();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
